import '../css/Common.css';

function Footer() {
    return (
      <div className="Common-all Common-footer">
        <footer>
            {/* <div className="Common-sub-description">
            이 페이지는 리디주식회사에서 제공한 리디바탕 글꼴이 사용되어 있습니다.
            </div> */}
            <div className="Common-sub-content-footer">
            Copyright 2023. 똥망부부 All right reserved.  
            </div>
        </footer>
      </div>
    )
};

export default Footer;
